import React, { Component } from "react";

import { reactLocalStorage } from "reactjs-localstorage";
// import { NaverMap } from "react-naver-maps";
import {
  Form,
  Modal,
  Input,
  Button,

} from "antd";
import { httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import { showAlert } from "../common/AlertModal";


const FormItem = Form.Item;
const HolidayRegistry = Form.create()(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        holiday:"",
        memo:"",
      
      };
      
    }

  


    onRegistry = (e) => {
      const { form } = this.props;

      e.preventDefault();
      form.validateFields((err, values) => {
        let createData = {
          ...values,
         
        };
      
        if (!err) {
          if (global.confirm("생성하시겠습니까?"))
            httpPost(httpUrl.HolidayCreate, [], createData)
              .then((res) => {
                if (res.data) {
                  this.props.onOk();
                  form.resetFields();
                  showAlert("create");
                } else {
                  
                    alert("알수없는 오류로 실패하였습니다. 가맹점 계정이 중복일수있습니다.");
                  
                }
              })
              .catch((error) => {
                alert("알수없는 오류로 실패하였습니다. 계정이 중복일수있습니다.");

              });
        }
      });
    };

    onCancel = () => {
      this.props.form.resetFields();
      this.props.onCancel();
      
    };

    componentDidMount() {}

    render() {
      const {
      
      } = this.state;
      const { visible, form, defaultValue, color } = this.props;
      const { getFieldDecorator } = form;
      
      const formItemLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 }
        }
      };

      

      return (
        <Modal
          visible={visible}
          title="공휴일 생성"
          okText="생성"
          cancelText="취소"
          onOk={this.onRegistry}
          onCancel={this.onCancel}
          style={{ minWidth: "400px" }}>
         
         <Form {...formItemLayout} onSubmit={this.onRegistry} >
        
        <FormItem label={<span>날짜&nbsp;</span>}>
          {getFieldDecorator("holiday", {
            rules: [
              {
                required: true,
                message: "날짜를 입력해주세요!",
                
              },
            ]
            
          })(<Input placeholder="ex)20201225" maxlength="8"/>)}
        </FormItem>             
        <FormItem label={<span>메모&nbsp;</span>}>
          {getFieldDecorator("memo", {
            rules: [
              {
                required: true,
                message: "메모를 입력해주세요!"
              },
              
            ]
  
          })(<Input placeholder="ex)성탄절" />)}
        </FormItem>       
             
          </Form>
        </Modal>
      );
    }
  }
);

export default HolidayRegistry;


